import type { PageProps } from "../pageProps";
import { LegalView } from "./legal/LegalView";
import { NOTTLDR_TERMS } from "./legal/terms";

export const TermsPage = (_props: PageProps) => <LegalView doc={NOTTLDR_TERMS} />;
